import { Moon, Sun } from "lucide-react";
import { useTheme } from "../context/ThemeContext";
import { Button } from "./ui/button";

export function ThemeToggle({ className = "" }) {
    const { theme, toggle } = useTheme();
    const isDark = theme === "dark-industrial";
    return (
        <Button
            variant="ghost"
            size="icon"
            onClick={toggle}
            className={`pw-tap ${className}`}
            aria-label={isDark ? "Zu Hell wechseln" : "Zu Dunkel wechseln"}
            data-testid="theme-toggle"
        >
            {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
        </Button>
    );
}

export default ThemeToggle;
